module.exports = __webpack_public_path__ + "static/media/open-in-new.7ea68fb1.svg";